import { Skeleton } from "antd";

import "./image-skeleton.style.less";

export const ImageSkeleton = () => {
  return (
    <div className="image-skeleton">
      <Skeleton.Image
        active
        classNames={{
          root: "image-skeleton--root",
          content: "image-skeleton--content",
        }}
      />
    </div>
  );
};
